module.exports = __webpack_public_path__ + "img/equipment-table-icon.afd984f9.svg";